import {
  captureException,
  isAbortError
} from '@tandemone/observability/browser'
import { isAxiosError } from 'axios'

import { type EndpointStamped } from '@/api/client'

/** 4xx are client errors, not faults — reporting them is noise. timeouts (408)
 * and rate-limits (429) are the exceptions worth seeing. */
function isExpectedClientError(error: unknown): boolean {
  if (!isAxiosError(error)) return false
  const status = error.response?.status
  return (
    status !== undefined &&
    status >= 400 &&
    status < 500 &&
    status !== 408 &&
    status !== 429
  )
}

/** report a react-query cache failure to sentry, skipping benign cancellations
 * and expected client errors. `extra` carries the queryKey/mutationKey; the
 * failing endpoint is read from the stamped axios error. */
export function reportCacheError(
  error: unknown,
  extra: Record<string, unknown>
): void {
  if (isAbortError(error) || isExpectedClientError(error)) return
  const err = error instanceof Error ? error : new Error(String(error))
  const endpoint = (error as EndpointStamped | null)?.endpoint ?? null
  captureException(err, { extra: { ...extra, endpoint } })
}
